/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SwimLane } from './swimLane';
import { CompanyBaseData } from './companyBaseData';


export interface CreateWorkflowDto { 
    name: string;
    description?: string;
    accessKeys?: Array<string>;
    workflowTypeId?: number;
    currentStepId?: number;
    lastStepId?: number;
    status?: string;
    attachExistingAssets: boolean;
    agencies?: Array<CompanyBaseData>;
    bulkUploadTask?: boolean;
    automaticTransitionWF?: boolean;
    automaticSubTaskCreationFlag?: boolean;
    allSteps?: Array<string>;
    numberOfSwimlane?: number;
    workflowSwimlanes?: Array<SwimLane>;
}

